export default __webpack_public_path__ + "static/media/teachablemachine.362fbba5.png";